import { useSearchParams } from "react-router-dom";
import Title from "../components/ui/Title";
import { useState } from "react";
import { Box, Grid, Stack, Tab, Tabs, Typography } from "@mui/material";
import { CustomTabPanel } from "../components/ui/CustomTabPanel";
import Overview from "../components/features/dashboard/Overview";
import OrderTab from "../components/features/dashboard/OrderTab";

import Shipment from "../components/features/dashboard/Shipment";
import Returns from "../components/features/dashboard/Returns";

// export const dashboardTab = [
//   {
//     label: "Overview",
//   },
//   {
//     label: "Orders",
//   },
//   {
//     label: "Returns",
//   },
//   // {
//   //   label: "Shipments",
//   // },
//   // {
//   //   label: "NDR",
//   // },
//   // {
//   //   label: "RTO",
//   // },
//   {
//     label: "Courier",
//   },
// ];

const Dashboard = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const username = localStorage.getItem("hipship-username") || "User";
  const showCourier = username === "Cipla";

  
  const dashboardTab = [
    { label: "Overview" },
    { label: "Orders" },
    { label: "Returns" },
    ...(!showCourier ? [{ label: "Courier" }] : []),
  ];
  const tab = searchParams.get("tab") || "Overview";

  const findIndexOfType = dashboardTab.findIndex((data) => {
    return data.label === tab;
  });

  const [activeTab, setActiveTab] = useState(findIndexOfType);

  const handleTabChange = (_event: React.SyntheticEvent, newValue: number) => {
    setActiveTab(newValue);
    searchParams.set("tab", dashboardTab[newValue].label);
    setSearchParams(searchParams);
  };

  return (
    <>
      <Title title="Dashboard" />
      <Box
        sx={{
          borderBottom: 1,
          borderColor: "divider",
        }}
      >
        <Tabs value={activeTab} onChange={handleTabChange} variant="scrollable">
          {dashboardTab.map((orderTab, index) => {
            return (
              <Tab
                key={index}
                label={<Typography>{orderTab.label}</Typography>}
              />
            );
          })}
        </Tabs>
      </Box>
      <CustomTabPanel value={activeTab} index={0}>
        <Overview />
      </CustomTabPanel>
      <CustomTabPanel value={activeTab} index={1}>
        <OrderTab />
      </CustomTabPanel>
      <CustomTabPanel value={activeTab} index={2}>
        <Returns />
      </CustomTabPanel>
      <CustomTabPanel value={activeTab} index={3}>
        <Shipment />
      </CustomTabPanel>
    </>
  );
};

export default Dashboard;
